// Imports for external libraries go here.
import React, { FC } from 'react';
import clsx from 'clsx';
import { Button, Types, Heading, RadioButton } from '@marriott/mi-ui-library';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { constants } from '../../../../modules/utils/constants/constants';
import { CreateAccountOtpTimer } from '../CreateAccountOtpTimer/CreateAccountOtpTimer';
import { CreateAccountConfirmIdentityProps } from './CreateAccountConfirmIdentity.types';
import { StyledCreateAccountConfirmIdentity } from './CreateAccountConfirmIdentity.styles';

// Use named rather than default exports.
export const CreateAccountConfirmIdentity: FC<CreateAccountConfirmIdentityProps> = props => {
  const { showSendCode, isLoading, handleEmailCodeChange, handlePhoneCodeChange, handleOtp, customClickTrackValue } =
    props;
  return (
    <StyledCreateAccountConfirmIdentity data-testid="account-CreateAccountConfirmIdentity">
      {
        <div className="d-flex flex-column justify-content-start confirm-identity">
          <div className="d-flex flex-column">
            <Heading
              customClass={'pb-2'}
              titleText={props?.confirmIdentityHeader}
              variation={Types.headingType.subtitle}
              fontSize={Types.size.medium}
            />
            <Heading
              titleText={props?.confirmIdentitySubHeader}
              variation={Types.headingType.body}
              fontSize={Types.size.small}
            />
          </div>
          <div className="d-flex flex-column">
            <RadioButton
              data-testid="phone"
              radiobuttonId="phone"
              radiobuttonName="phone"
              radiobuttonLabel={props?.sendCodePhoneLabel}
              checked={props?.selectedOption === constants.PHONE}
              onChange={handlePhoneCodeChange}
              value="phone"
              setTabIndex={props?.disablePhoneSendCode ? -1 : 0}
              labelClassName="confirm-identity__radio_btn t-font-s pb-3"
              aria-label="confirm-phone"
              disabled={props?.disablePhoneSendCode}
            />
            <RadioButton
              data-testid="email"
              radiobuttonId="email"
              radiobuttonName="email"
              radiobuttonLabel={props?.sendCodeEmailLabel}
              checked={props?.selectedOption === constants.EMAIL}
              onChange={handleEmailCodeChange}
              value="email"
              setTabIndex={0}
              labelClassName="confirm-identity__radio_btn t-font-s"
              aria-label="confirm-email"
            />
          </div>
          <div className="d-flex flex-column">
            <Button
              type={Types.ButtonTypeVariation.Button}
              testId="send-code-btn"
              className={clsx(
                'confirm-identity__send-code px-3 m-button-m m-button-primary',
                showSendCode || isLoading ? 'disabled' : ''
              )}
              isLink={false}
              callback={handleOtp}
              isDisabled={isLoading || showSendCode}
              {...(customClickTrackValue && { custom_click_track_value: customClickTrackValue })}
            >
              {props?.sendCodeButtonLabel}
            </Button>
            <div className={clsx({ 'pt-3': showSendCode })}>
              <CreateAccountOtpTimer
                showSendCode={showSendCode}
                disableField={props?.disableField}
                enableTimer={props?.enableTimer}
                otpTimer={props?.timer}
                handleOtp={handleOtp}
                handleTimerActiveChange={props?.handleTimerActiveChange}
                isOtpSent={props?.isOtpSent}
                timerRunningLabel={props?.timerRunningLabel}
                resendNewCodeLabel={props?.resendNewCodeLabel}
                otpValidationError={props?.otpValidationError}
                incorrectCodeRunningLabel={props?.incorrectCodeRunningLabel}
                verificationCodeInlineMessage={props?.verificationCodeInlineMessage}
                didNotGetACodeLabel={props?.didNotGetACodeLabel}
                resetTimer={props?.resetTimer}
                incorrectVerificationCode={props?.incorrectVerificationCode}
                expiredTransactionCode={props?.expiredTransactionCode}
                selectedOption={props?.selectedOption}
              />
            </div>
          </div>
          <div className="confirm-identity__horizantal-line"></div>
        </div>
      }
    </StyledCreateAccountConfirmIdentity>
  );
};
